export const addChoice = (id) => {
    return {
        type: 'ADD_CHOICE',
        id
    };
};

export const clearChoices = () => {
    return {
        type: 'CLEAR_CHOICE',
    };
};


export function productHasBeenChosen(product_id, choices) {
    if(!choices) return false;
    for (let i = 0, len = choices.length; i < len; i++) {
        const choice_id = choices[i];
        if(choice_id == product_id) return true;
    }
    return false;
}



// WEBPACK FOOTER //
// ./src/actions/choiceActions.js